import React from 'react';
import styles from './Footer.module.css';

const Footer = () => (
  <footer className={styles.footerMain}>
    <div className={styles.container}>
      <div className={styles.columns}>
        {/* Столбец 1: Логотип + реквизиты самозанятого */}
        <div className={styles.columnBrand}>
          <a href="/" className={styles.brandLink}>
            <img src="/newlogo.png" alt="INTERWORLD" className={styles.brandLogo} />
          </a>
          <div className={styles.legalInfo}>
            <p className={styles.legalLine}>Самозанятый</p>
            <p className={styles.legalLine}>Сопов Артем Игоревич</p>
            <p className={styles.legalLine}>ИНН: <span className={styles.inn}>780737781518</span></p>
          </div>
        </div>

        {/* Столбец 2: Игрокам */}
        <div className={styles.column}>
          <p className={styles.columnTitle}>Игрокам</p>
          <ul className={styles.columnList}>
            <li><a href="/getting-started">Как начать играть</a></li>
            <li><a href="/donate">Магазин</a></li>
            <li><a href="/rating">Рейтинг</a></li>
            <li><a href="/tournaments">Турниры</a></li>
            <li><a href="/wiki">Вики</a></li>
          </ul>
        </div>

        {/* Столбец 3: Важная информация */}
        <div className={styles.column}>
          <p className={styles.columnTitle}>Важная информация</p>
          <ul className={styles.columnList}>
            <li><a href="/public-offer">Публичная оферта</a></li>
            <li><a href="/terms">Пользовательское соглашение</a></li>
            <li><a href="/server-rules">Правила сервера</a></li>
            <li><a href="/privacy">Политика конфиденциальности</a></li>
          </ul>
        </div>

        {/* Столбец 4: Контакты */}
        <div id="contacts" className={styles.column}>
          <p className={styles.columnTitle}>Контакты</p>
          <ul className={styles.columnList}>
            <li>
              <a href="/contacts">Страница контактов →</a>
            </li>
            <li>
              Telegram: <a href="https://t.me/interworld_support_bot" target="_blank" rel="noreferrer">@interworld_support_bot</a>
            </li>
            <li>
              Поддержка: <a href="mailto:support@interworld.fun">support@interworld.fun</a>
            </li>
          </ul>
        </div>
      </div>

      <p className={styles.copyright}>© 2026 InterWorld</p>
    </div>
  </footer>
);

export default Footer;
